
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';
import { SliderComponent } from './slider/slider.component';
import { HeaderComponent } from './header/header.component';
import { TariffsComponent } from './tariffs/tariffs.component';
import { FooterComponent } from './footer/footer.component';
import { MainInfoComponent } from './main-info/main-info.component';
import { MemberComponent } from './member/member.component';
import { GalleryComponent } from './gallery/gallery.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {GalleriaModule} from 'primeng/galleria';
import {CardModule} from 'primeng/card';
import {DialogModule} from 'primeng/dialog';
import {providePrimeNG} from 'primeng/config';
import Aura from '@primeuix/themes/aura';
@NgModule({ declarations: [
        AppComponent,
        SliderComponent,
        HeaderComponent,
        TariffsComponent,
        FooterComponent,
        MainInfoComponent,
        MemberComponent,
        GalleryComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        GalleriaModule,
        CardModule,
        DialogModule], providers: [
        provideHttpClient(withInterceptorsFromDi()),
        providePrimeNG({
            theme: {
                preset: Aura
            }
        })
    ] })
export class AppModule { }


